var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightAlign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right align"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1234 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.8H18.2V10.2H8C7.88954 10.2 7.8 10.1105 7.8 10V6C7.8 5.88954 7.88954 5.8 8 5.8ZM19 5V11H8C7.44772 11 7 10.5523 7 10V6C7 5.44772 7.44771 5 8 5H19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1235 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.8H18.2V18.2H4C3.88954 18.2 3.8 18.1105 3.8 18V14C3.8 13.8895 3.88954 13.8 4 13.8ZM19 13V19H4C3.44771 19 3 18.5523 3 18V14C3 13.4477 3.44771 13 4 13H19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 36 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6 1.59961C18.3791 1.59961 18.2 1.7787 18.2 1.99961L18.2 20.9996C18.2 21.2205 18.3791 21.3996 18.6 21.3996C18.8209 21.3996 19 21.2205 19 20.9996L19 1.99961C19 1.7787 18.8209 1.59961 18.6 1.59961Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlign);
export default __webpack_public_path__ + "static/media/right_Align.822af114334990619e9f35e35dc728af.svg";
export { ForwardRef as ReactComponent };